import { CanActivateFn, Router } from "@angular/router";
import { CaptchaService } from "../services/captcha-service";
import { inject } from "@angular/core";
import { map, take } from "rxjs";

export const captchaAuthGuard: CanActivateFn = (route, state) => {
 const captchaService = inject(CaptchaService);
 const router = inject(Router);

 return captchaService.isVerified$.pipe(
   take(1),
   map(isVerified => {
     if (isVerified) {
       return true;
     } else {
       // IMPORTANTE: Se o captcha não foi validado, não redirecione para '/' se o usuário já estiver em 'login'.
       // Se tentarmos navegar para onde já estamos, o Angular pode limpar os queryParams.

       const currentUrl = state.url.split('?')[0];

       console.log('URL atual:', currentUrl)
       if (currentUrl === '/login' || currentUrl === '/') {
         // Já estamos na tela de login, apenas bloqueamos a ação (o componente carregará mas o Guard impede ativações extras)
         return true; // Permitimos carregar a rota de login para o usuário ver o formulário
       }

       // Se ele tentou acessar outra rota protegida, mandamos para o login preservando os parâmetros
       router.navigate(['/login'], {
         queryParams: route.queryParams,
         queryParamsHandling: 'merge' // Garante a fusão dos parâmetros
       });
       return false;
     }
   })
 );
}